import { render, staticRenderFns } from "./OperaLabelsFeeAreaWindow.vue?vue&type=template&id=ace18c82&scoped=true&"
import script from "./OperaLabelsFeeAreaWindow.vue?vue&type=script&lang=js&"
export * from "./OperaLabelsFeeAreaWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaLabelsFeeAreaWindow.vue?vue&type=style&index=0&id=ace18c82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace18c82",
  null
  
)

export default component.exports